import React from "react";
import SetItemPricesGenericSkeleton from "./SetItemPricesGenericSkeleton";

const SetItemsPricesDetailsSkeleton = () => {
  return (
    <>
      <SetItemPricesGenericSkeleton />
    </>
  );
};

export default SetItemsPricesDetailsSkeleton;
